import * as Sentry from '@sentry/react'

import { router } from './router'

const dsn = import.meta.env.VITE_SENTRY_DSN
const apiUrl = import.meta.env.VITE_APP_API

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
    tracePropagationTargets: [
      'localhost',
      window.location.origin,
      ...(apiUrl ? [apiUrl] : []),
    ],
  })
}
